import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { API_URL } from '../../env'
import { useDispatch, useSelector } from 'react-redux'
import { saveDataStoreUser } from '../../store/user/userAction'
import axios from 'axios'
import { ThreeCircles } from 'react-loader-spinner'
import { Col, Row } from 'react-bootstrap'
import { sha512 } from 'js-sha512'
import { toast } from 'react-toastify'
import { Fade } from 'react-awesome-reveal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock, faRightToBracket, faUser } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Admin/AdminSignIn.css'
import InputText from '../Input/InputText'
import Button from '../Utils/Button'
import logo from '../../assets/logo.jpg'

function AdminSignIn({ ip }) {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const userSaveStore = (userData) => dispatch(saveDataStoreUser(userData))
    const userInfo = useSelector((state) => state.userReducer)
    const [isLoading, setIsLoading] = useState(true)
    const emailRef = useRef(null)
    const [email, setEmail] = useState(userInfo.email ? userInfo.email : "")
    const [emailError, setEmailError] = useState(null)
    const passwordRef = useRef(null)
    const [password, setPassword] = useState("")
    const [passwordError, setPasswordError] = useState(null)

    useEffect(() => {

        if (ip) {
            signInRecover()
        }

    }, [ip])

    function signIn() {

        setIsLoading(true)
        var error = []
        if (!emailRef.current.emailValidationOnBlur(email)) {
            error.push("L'email est incorrect")
        }
        if (!passwordRef.current.passwordValidation(password)) {
            error.push("Le mot de passe est incorrect")
        }
        const passwordFormat = sha512(password).slice(3, 67)
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Connexion...")
            axios.get(API_URL + 'user/signIn', {
                params: {
                    email: email,
                    password: passwordFormat,
                    ip: ip
                }
            }).then((response) => {
                if (response.data.message === "CONNECTED") {
                    userSaveStore({ email: email, tokenJWT: response.data.tokenJWT })
                    toast.update(toastId, { render: "Bonjour Florent", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    navigate('/administration/diagnostic/0')
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_USER_NOT_FOUND") {
                        errorMessage = "L'utilisateur est introuvable"
                    } else if (errorMessage === "ERROR_PASSWORD") {
                        errorMessage = "Le mot de passe est incorrect"
                    } else if (errorMessage === "ERROR_TOKENJWT") {
                        errorMessage = "Erreur lors de la connexion (tokenJWT)"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }

    }

    function signInRecover() {

        if (userInfo.tokenJWT) {
            const toastId = toast.loading("Connexion...")
            axios.get(API_URL + 'user/signInVerification', {
                params: {
                    tokenJWT: userInfo.tokenJWT,
                    ip: ip
                }
            }).then((response) => {
                if (response.data === "CONNECTED") {
                    toast.update(toastId, { render: "Bonjour Florent", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    navigate('/administration/diagnostic/0')
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_TOKENJWT" || errorMessage === "FORBIDDEN") {
                        errorMessage = "Erreur lors de la connexion automatique"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        } else {
            setIsLoading(false)
        }

    }

    return (

        <div id='adminSignIn'>
            <Row>
                <Col sm={8}>
                    <Fade direction={'down'}>
                        <div id='adminSignInLeft'>
                            <div id='adminSignInLeftTitle'>Administration</div>
                            <img src={logo} id='adminSignInLeftLogo' alt='logo' />
                        </div>
                    </Fade>
                </Col>
                <Col sm={4}>
                    <Fade direction={'up'}>
                        <div id='adminSignInRight'>
                            <div id='adminSignInRightTitle'>Connexion</div>
                            <InputText
                                type={'email'}
                                theme={'dark'}
                                ref={emailRef}
                                text={email} setText={setEmail}
                                textError={emailError} setTextError={setEmailError}
                                icon={<FontAwesomeIcon icon={faUser} />}
                                placeholder={"Email"}
                                maxLength={128}
                                onPressEnter={() => passwordRef.current.inputTextRef.current.focus()}
                            />
                            <InputText
                                type={'password'}
                                theme={'dark'}
                                ref={passwordRef}
                                text={password} setText={setPassword}
                                textError={passwordError} setTextError={setPasswordError}
                                icon={<FontAwesomeIcon icon={faLock} />}
                                placeholder={"Mot de passe"}
                                passwordButtonVisible={true}
                                maxLength={32}
                                onPressEnter={() => signIn()}
                            />
                            <div id='adminSignInRightButton'>
                                {!isLoading ?
                                    <Button theme={'dark'} rounded={true} icon={<FontAwesomeIcon icon={faRightToBracket} />} text={"Se connecter"} onClick={() => signIn()} />
                                    :
                                    <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} />
                                }
                            </div>
                        </div>
                    </Fade>
                </Col>
            </Row>
        </div>

    )

}

export default AdminSignIn